export default "__VITE_ASSET__BsIo623X__"